import { Student, StudentInfo } from "../../../../store/onboarding/types";
import { ApplicationState } from "../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import {
  addStudents,
  clearAddStudentsError,
  getStudents,
  hideStudentInviteIndividuallyModal,
  resetFromStudentInviteModal,
} from "../../../../store/onboarding/actions";
import { connect } from "react-redux";
import StudentsInviteIndividuallyModal from "../../../../components/common/onboarding/second-step/students/StudentsInviteIndividuallyModal";
import { UserAssignmentRole } from "../../../../store/auth/types";

type PropsFromState = {
  isLoading: {
    getStudents: boolean;
    addStudents: boolean;
  };
  error?: {
    addStudents?: string | Array<any>;
  };
  modalShow: boolean;
  existingStudents: number[];
  isStudentRosterUploaded?: boolean;
  fromStudentInviteModal?: boolean;
  newStudents?: number[];
  isCoach?: boolean;
  isDistrictAdmin?: boolean;
  studentsRoster: StudentInfo[];
};

type DispatchProps = {
  addStudents: (students: Array<Student>) => any;
  onModalHide: () => void;
  getStudents: () => any;
  clearAddStudentsError: () =>  any;
  resetFromStudentInviteModal: () => any;
};

const mapStateToProps = ({ onboarding, auth }: ApplicationState): PropsFromState => {
  return {
    modalShow: onboarding.modalsState.studentsIndividuallyInviteModal,
    error: { addStudents: onboarding.errors.addStudents },
    isLoading: {
      getStudents: onboarding.isLoading.getStudents,
      addStudents: onboarding.isLoading.addStudents,
    },
    isStudentRosterUploaded: onboarding.isStudentRosterUploaded,
    fromStudentInviteModal: onboarding.fromStudentInviteModal,
    existingStudents: onboarding.existingStudents,
    newStudents: onboarding.newStudents,
    isCoach: auth.userInfo?.profile.current_role === UserAssignmentRole.COACH,
    isDistrictAdmin: auth.userInfo?.profile.current_role === UserAssignmentRole.DISTRICT_OWNER,
    studentsRoster: onboarding.studentsRoster,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      onModalHide: hideStudentInviteIndividuallyModal,
      addStudents: addStudents,
      getStudents: getStudents,
      clearAddStudentsError: clearAddStudentsError,
      resetFromStudentInviteModal: resetFromStudentInviteModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentsInviteIndividuallyModal);
